import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { DEFAULT_ASSETS } from '../../helpers'
import { useAsset, useTenant } from '../../hooks'
import { useActions } from '../../store'

const AssetsProvider = ({ children }) => {
  const {
    setApplicationName,
    setImgSrcLogin,
    setImgAltLogin,
    setImgSrcLogo,
    setImgAltLogo
  } = useActions()
  const { tenant } = useTenant()
  const { asset: css } = useAsset(tenant?.cssId)
  const { asset: login } = useAsset(tenant?.loginImageId)
  const { asset: logo } = useAsset(tenant?.logoImageId)

  useEffect(() => {
    setApplicationName(
      tenant
        ? `${tenant.name} - ${DEFAULT_ASSETS.applicationName}`
        : DEFAULT_ASSETS.applicationName
    )
  }, [tenant, setApplicationName])

  useEffect(() => {
    setImgSrcLogin(
      login
        ? `data:${login.contentType};base64,${login.content}`
        : DEFAULT_ASSETS.imgSrcLogin
    )
  }, [login, setImgSrcLogin])

  useEffect(() => {
    setImgAltLogin(login ? login.altText : DEFAULT_ASSETS.imgAltLogin)
  }, [login, setImgAltLogin])

  useEffect(() => {
    setImgSrcLogo(
      logo
        ? `data:${logo.contentType};base64,${logo.content}`
        : DEFAULT_ASSETS.imgSrcLogo
    )
  }, [logo, setImgSrcLogo])

  useEffect(() => {
    setImgAltLogo(logo ? logo.altText : DEFAULT_ASSETS.imgAltLogo)
  }, [logo, setImgAltLogo])

  return (
    <>
      {
        <Helmet>
          <link
            rel='stylesheet'
            type='text/css'
            href={
              css
                ? `data:${css.contentType};base64,${css.content}`
                : '/main.css'
            }
          />
        </Helmet>
      }
      {children}
    </>
  )
}

AssetsProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export { AssetsProvider }
